// extracted by mini-css-extract-plugin
module.exports = {"ComponentRow":"styles_ComponentRow__3bexN","TableFooter":"styles_TableFooter__CG0YJ"};